// extracted by mini-css-extract-plugin
export default {"container":"HomePage_container__2ypMu","heading":"HomePage_heading__a9Bwq","link":"HomePage_link__FqsZ8"};